import React from 'react';
import styled from 'styled-components';
import query from '@catalogo/service-americanas-login/src/queries/recProduct.graphql';
import RecProduct from './rec-product';

const Rec = ({ title, products, position, pageType, hasRecommendations }) => (
  <Wrapper>
    <Title>{title}</Title>
    {products.slice(0, 2).map((product, index) => (
      <RecProduct
        id={product.id}
        sellerId={product.sellerId}
        index={index}
        key={product.id}
        position={position}
        pageType={pageType}
        queryString={product.queryString}
        query={query}
        hasRecommendations={hasRecommendations}
      />
    ))}
  </Wrapper>
);

const Wrapper = styled.div`
  height: 305px;
  width: 280px;
  border-radius: 4px;
  background: ${({ theme }) => theme.white};
  box-shadow: 0 6px 20px -1px rgba(0, 0, 0, 0.12);
  margin: 0 15px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const Title = styled.span`
  color: ${({ theme }) => theme.grey.dark};
  font-size: 18px;
  font-weight: bold;
  text-transform: lowercase;
`;

export default Rec;
